export default "__VITE_ASSET__DkZT0LiV__"